import { ElementRef } from '@angular/core';
import { Commands, Search } from '@local/client-contracts';
import { ContextMenuService } from '@shared/components';
import { ResourcesService } from '@shared/services/resources.service';
import { Logger } from '@unleash-tech/js-logger';
import { ContextMenuInvokeSource, ResultsItemContextMenuHelper } from 'src/app/bar/services/commands/results-item-context-menu-helper';
import { GoLinksService } from 'src/app/bar/services/go-links.service';
import { GlobalErrorHandler } from 'src/app/global-error-handler';
import { ResultCommandBuilderParams } from '../../results/services/result-command-builder.service';
import { GoLinkCommandBuilder, GoLinkCommandBuilderParams, KeyValue } from './go-link-command-builder.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { WorkspacesService } from 'src/app/bar/services';
import { FlagsService } from '@shared/services/flags.service';

export class GoLinksContextMenuHelper extends ResultsItemContextMenuHelper {
  constructor(
    builder: GoLinkCommandBuilder,
    logger: Logger,
    contextMenuService: ContextMenuService,
    hostRef: ElementRef,
    titleRef: ElementRef,
    subtitleRef: ElementRef,
    actionsRef: ElementRef,
    errorHandler: GlobalErrorHandler,
    resourcesService: ResourcesService,
    hubService: HubService,
    protected flagsService: FlagsService,
    private workspacesService: WorkspacesService,
    private goLinkService: GoLinksService
  ) {
    super(
      builder,
      logger,
      contextMenuService,
      hostRef,
      titleRef,
      subtitleRef,
      actionsRef,
      errorHandler,
      resourcesService,
      hubService,
      flagsService,
      workspacesService
    );
  }

  async buildItemsRequest(
    state?: Commands.PreviewState,
    model?: Search.GoLinkResultItem,
    source?: ContextMenuInvokeSource,
    isPopUp?: boolean,
    previewable = false,
    actionsReadOnly = false
  ): Promise<GoLinkCommandBuilderParams> {
    const itemsRequest: ResultCommandBuilderParams = await super.buildItemsRequest(state, model, source, isPopUp);
    let copyGoLink: KeyValue;
    let edit: KeyValue;
    let deleted: KeyValue;
    let share: KeyValue;
    if (model.view.title.text) {
      copyGoLink = { key: 'copyGoLink', value: model.view.title.text };
    }
    if (!actionsReadOnly && this.goLinkService.canEditOrDelete(model.data)) {
      edit = { key: 'edit', value: model.data.nameId };
      deleted = { key: 'delete', value: model.data.id };
      share = { key: 'share', value: model.data.id };
    }
    const dynamicCommands = model?.dynamicCommands || itemsRequest.dynamicCommands;
    return { ...itemsRequest, copyGoLink, edit, delete: deleted, share, dynamicCommands };
  }
}
